import Content from '../../content';

namespace('IO.Views.Servers', function (exports) {
  'use strict';

  var DynamicGroupForm = IO.Views.Components.DynamicGroupForm,
    Show = Content.extend({
      dom: {
        MASKED_PASSWORD: '.mask-password',
        CURRENT_HOSTNAME_FORM: '.server-form .current-hostname',
        TYPE_OF_SERVER_SELECTOR: '#server_type_of_server',
        SERVER_FORM: '.server-form',
        SELECT2_FIELD: '.select2select',
        PUPPET_PROFILES: '#server_puppet_profiles',
        IMPACT_FORM: '#impact-form',
        IMPACT_CANCEL: '#impact-form .io-form-action-cancel',
        SAVE_BUTTON: '#impact-form .io-form-action-save',
      },

      events: function () {
        var events = {};

        events['click ' + this.dom.IMPACT_CANCEL] = '_impactCancel';
        events['click ' + this.dom.SAVE_BUTTON] = '_impactSave';

        return events;
      },

      afterRender: function () {
        this.listenTo(this.dynamicForm, 'after:filter', this.checkRadioButtons);
      },

      /*
        PUBLIC FUNCTIONS
      */
      render: function () {
        this.puppetProfilesOrder = new PuppetProfilesOrder(
          this.$(this.dom.SERVER_FORM),
        );
        this.dynamicForm = new DynamicGroupForm({
          el: this.$el,
          formTarget: this.dom.SERVER_FORM,
          radio: true,
        });
        this.dynamicForm.render();

        this.$(this.dom.MASKED_PASSWORD).maskPassword();
        this.hostname = this.$(this.dom.CURRENT_HOSTNAME_FORM).val();

        this.$(this.dom.SELECT2_FIELD).select2();
        new ServerTypeWarning({ selector: this.dom.TYPE_OF_SERVER_SELECTOR });
      },

      _impactCancel: function (e) {
        var form = $(this.dom.IMPACT_FORM);

        e.preventDefault();
        form.append('<input name="edit" type="hidden" value="1" />');
        form[0].action = form[0].baseURI;
        form.submit();
      },

      _impactSave: function (e) {
        var form = $(this.dom.IMPACT_FORM);

        e.preventDefault();
        form[0].action = form[0].baseURI;
        form.submit();
      },
    });

  exports.Show = Show;
});
